// frontend/src/pages/dashboard/TaskComponents/TaskAttachmentDialog.js

import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  List,
  ListItem,
  ListItemText,
  IconButton,
} from "@mui/material";
import { Download as DownloadIcon } from "@mui/icons-material";

const TaskAttachmentDialog = ({
  open,
  onClose,
  selectedTaskAttachments,
  handleDownload,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Task Attachments</DialogTitle>
      <DialogContent>
        {selectedTaskAttachments.length > 0 ? (
          <List dense>
            {selectedTaskAttachments.map((att) => (
              <ListItem
                key={att.id}
                secondaryAction={
                  <IconButton onClick={() => handleDownload(att)} color="primary">
                    <DownloadIcon />
                  </IconButton>
                }
              >
                <ListItemText
                  primary={att.original_name}
                  secondary={`${(att.size / 1024).toFixed(1)} KB`}
                />
              </ListItem>
            ))}
          </List>
        ) : (
          <Typography color="text.secondary">No attachments.</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default TaskAttachmentDialog;